import { useMediaQuery } from '@mui/material';
import { constant, pipe } from 'fp-ts/function';
import * as O from 'fp-ts/Option';
import * as t from 'io-ts';
import { JsonFromString } from 'io-ts-types';
import { useCallback, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
var ScrollablePath = JsonFromString.pipe(t.type({
  path: t.string,
  scroll: t.number
}));
export var ScrollRestoration = function ScrollRestoration(_ref) {
  var whiteList = _ref.whiteList;

  var _useLocation = useLocation(),
      pathname = _useLocation.pathname;

  var isMobile = useMediaQuery(function (theme) {
    return "(max-width:".concat(theme.breakpoints.values.md, "px)");
  });
  var lastKnownScrollPosition = 0;
  var watchScroll = useCallback(function () {
    lastKnownScrollPosition = window.scrollY;
  }, [pathname]);
  useEffect(function () {
    if (!isMobile) return;

    var _pipe = pipe(sessionStorage.getItem("".concat(pathname, "PathAndScroll")), O.fromNullable, O.chain(function (x) {
      return O.getRight(ScrollablePath.decode(x));
    }), O.getOrElse(constant({
      path: '',
      scroll: 0
    }))),
        path = _pipe.path,
        scroll = _pipe.scroll;

    if (path === pathname) {
      window.scrollTo(0, scroll);
      sessionStorage.removeItem("".concat(pathname, "PathAndScroll"));
    } else {
      window.scrollTo(0, 0);
    }

    if (whiteList.includes(pathname)) {
      window.addEventListener('scroll', watchScroll);
      return function () {
        window.removeEventListener('scroll', watchScroll);

        if (whiteList.includes(pathname)) {
          sessionStorage.setItem("".concat(pathname, "PathAndScroll"), ScrollablePath.encode({
            path: pathname,
            scroll: lastKnownScrollPosition
          }));
        }
      };
    }
  }, [pathname, isMobile]);
  return null;
};